const AuthFormLabel = ({ htmlFor, children, className = '' }: any) => (
    <label
        htmlFor={htmlFor}
        className={`w-full md:w-[21rem] text-sm font-medium text-slate-600 text-left ${className}`}
    >
        {children}
    </label>
);

export default AuthFormLabel;
